import React from "react";
import { motion } from "framer-motion";
import { FiArrowDown, FiCheckCircle } from "react-icons/fi";
import PageBanner from "../../components/PageBanner";

/* The copy is the supplied Training Services artwork's own — its title,
   tagline and four strengths — set as HTML instead of being baked into the
   picture. The artwork's footer (web address, phone, email) is left out: the
   page's contact section already carries those. The page's H1 stays in
   TrainingIntro directly below. */
const STRENGTHS = [
  "Expert Trainers",
  "Practical Learning",
  "Improve Performance",
  "Internationally Recognized",
];

const TrainingBanner = () => (
  <PageBanner
    image="/assets/banners/training-banner.jpeg"
    imageAlt="An MBA Solutions trainer leading a classroom training session"
    focus="55% 38%"
    variant="wide"
    ariaLabel="MBA Solutions training services"
  >
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <p className="page-banner__eyebrow">Training</p>
      <p className="page-banner__title">
        Training <em>Services</em>
      </p>
      <p className="page-banner__lead">
        Empowering People. Enhancing Performance.
      </p>
      <ul className="about-banner__strengths">
        {STRENGTHS.map((item) => (
          <li key={item}>
            <FiCheckCircle aria-hidden="true" /> {item}
          </li>
        ))}
      </ul>
      <div className="page-banner__actions">
        <a href="#featured-courses" className="page-banner__btn page-banner__btn--solid">
          Explore Courses <FiArrowDown aria-hidden="true" />
        </a>
      </div>
    </motion.div>
  </PageBanner>
);

export default TrainingBanner;
